(function() {
    var script = document.createElement('script');
    script.src = "https://fastrr-boost-ui.pickrr.com/assets/js/channels/shopify.js";
    script.defer = true; // Ensures the script is loaded after parsing HTML
    document.head.appendChild(script); // Adds the script tag to the <head> section
})();
